import { parseHostname } from '@/lib/parseHostname'
import { breakpoints as bp, spacing } from '@/materials'
import styled from '@emotion/styled'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import * as R from '../../apps/ballot/standalone/routes'

interface Props {
  popularVoteId: string
  activeTab: 'federal' | 'cantonal'
  isInApp?: boolean
}

export const PopularVotePageTabs = React.memo<Props>(({ popularVoteId, activeTab, isInApp }) => {
  const homeURL = `https://www.${parseHostname().publicationDomain}`
  return (
    <Space>
      <TopNavigation>
        {!isInApp && (
          <HomeLink>
            <a href={homeURL} target="_top">
              <svg width="24" height="24" className="icon-home">
                <path
                  strokeWidth="1.5"
                  fill="none"
                  d="M14.4990794 20.0390074h5.5V11l-8-8L4 10.9990794v9.039928h5.84741406v-5.8373212h4.65166534z"
                ></path>
              </svg>
            </a>{' '}
          </HomeLink>
        )}
        <TopNavigationLink to={R.popularVoteFederal(popularVoteId)} active={activeTab == 'federal'}>
          <FormattedMessage
            id="components.popular-vote-page-tabs.federal"
            defaultMessage="Eidgenössisch"
            tagName={React.Fragment}
          />
        </TopNavigationLink>
        <TopNavigationLink to={R.popularVoteCantonal(popularVoteId)} active={activeTab == 'cantonal'}>
          <FormattedMessage
            id="components.popular-vote-page-tabs.cantonal"
            defaultMessage="Kantonal"
            tagName={React.Fragment}
          />
        </TopNavigationLink>
      </TopNavigation>
    </Space>
  )
})

const TopNavigation = styled('div')`
  border-top: 1px solid var(--color-gray-gray-4);
  border-bottom: 1px solid var(--color-gray-gray-4);
  display: flex;
  height: 2.5rem;
`
const HomeLink = styled('div')`
  display: flex;
  align-items: center;
  stroke: var(--text-color);
  a {
    z-index: 100;
    margin-right: 0;
    padding-right: 1rem;
    border-right: 0.1rem solid var(--color-gray-gray-4);
    display: flex;
  }
  svg {
    display: flex;
  }
`
const TopNavigationLink = styled(({ active: _, ...rest }) => <Link {...rest} />)`
  font-family: var(--font-sans-serif);
  color: var(--text-color);
  font-size: 14px;
  font-weight: ${(props: any) => (props.active ? '700' : '400')};
  margin: 0 15px;
  line-height: 2.6;
  letter-spacing: 1px;
  border-bottom: ${(props: any) => (props.active ? '2px solid var(--text-color)' : 'none')};
`

const Space = styled('div')`
  ${spacing.mt3};
  ${spacing.mb4};
  ${bp.medium`${spacing.mt4};${spacing.mb5};`}
  ${bp.large`${spacing.mt4};${spacing.mb6};`}
`
